import { render } from "./jobtittle.vue?vue&type=template&id=c2e24c9a"
import script from "./jobtittle.vue?vue&type=script&lang=js"
export * from "./jobtittle.vue?vue&type=script&lang=js"

import "./jobtittle.vue?vue&type=style&index=0&id=c2e24c9a&lang=css"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__